import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AgileStudioAuthService } from 'src/app/Services/agile-studio-auth.service';
import { SharedService } from 'src/app/Services/shared.service';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-agile-integration-view',
  templateUrl: './agile-integration-view.component.html',
  styleUrls: ['./agile-integration-view.component.scss']
})
export class AgileIntegrationViewComponent implements OnInit {
  brand = getBrand();
  isAgileStudioIntegrationExists: boolean = false;
  isAgileIntegrationPopupVisible: boolean = false;
  username: string = '';
  password: string = '';
  returnUrl: string;

  constructor(private sharedService: SharedService,
    private agileStudioService: AgileStudioAuthService, 
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/project';
    this.sharedService.loaderHide.emit(true);
    this.checkIsAgileStudioIntegrated();
  }

  checkIsAgileStudioIntegrated() {
    this.agileStudioService.isAgileStudioIntegrationAvailable().subscribe(data => {
      if (data["data"] == null || data["operationStatus"] == "ERROR") {
        this.isAgileStudioIntegrationExists = false;
      } else {
        this.isAgileStudioIntegrationExists = true;
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  openAgileStudioIntegrationPopUp() {
    this.isAgileIntegrationPopupVisible = true;
  }

  integrateAgile() {
    this.sharedService.loaderHide.emit(true);
    if (this.username && this.password) {
      this.agileStudioService.agileStudioAuthToken(this.username, this.password).subscribe((response: any) => {
        if (response && response["operationStatus"] == "SUCCESS") {
          this.isAgileStudioIntegrationExists = true;
          this.isAgileIntegrationPopupVisible = false;
        } else {
          console.log('Please enter both username and password');
        }
        this.sharedService.loaderHide.emit(false);
      }, error => {
        this.sharedService.loaderHide.emit(false);
      })
    }
  }

  closeAgileIntegrationPopup() {
    this.isAgileIntegrationPopupVisible = false;
    this.username = '';
    this.password = '';
  }

  navigatePreviousUrl(): void {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
    } else {
      this.router.navigate(['/project']);
    }
  }
}
